import { render, staticRenderFns } from "./ObjectTelegramGroups.vue?vue&type=template&id=27d9b742&scoped=true&"
import script from "./ObjectTelegramGroups.vue?vue&type=script&lang=js&"
export * from "./ObjectTelegramGroups.vue?vue&type=script&lang=js&"
import style0 from "./ObjectTelegramGroups.vue?vue&type=style&index=0&id=27d9b742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d9b742",
  null
  
)

export default component.exports